export const SHOW_ERROR_PAGE = 'SHOW_ERROR_PAGE';
export const REMOVE_ERROR_PAGE = 'REMOVE_ERROR_PAGE';
export const ERROR_PAGE_LOADED_ANALYTICS = 'ERROR_PAGE_LOADED_ANALYTICS';
